import { Lightbulb } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function CaptureGuidance() {
  const { t } = useTranslation();

  const tips = [
    t('documents.guidance.tip1'),
    t('documents.guidance.tip2'),
    t('documents.guidance.tip3'),
    t('documents.guidance.tip4'),
  ];

  return (
    <div className='bg-amber-50 border border-amber-200 rounded-lg p-4'>
      <div className='flex items-center gap-2 mb-2'>
        <Lightbulb size={16} className='text-amber-600' />
        <h4 className='text-sm font-semibold text-amber-800'>{t('documents.guidance.title')}</h4>
      </div>
      <ul className='space-y-1'>
        {tips.map((tip) => (
          <li key={tip} className='text-sm text-amber-700 flex items-start gap-2'>
            <span className='text-amber-400 mt-1 shrink-0'>&#8226;</span>
            {tip}
          </li>
        ))}
      </ul>
    </div>
  );
}
